<template>
  <div class="flex align-items-center gap-[16px]">
    <p class="font-normal text-base text-gray-600">1 - 50 of 2500</p>
    <img class="cursor-pointer" src="@/assets/svg/arrow-left-grey.svg" />
    <p class="font-normal text-base text-gray-600">1 - 10</p>
    <img class="cursor-pointer" src="@/assets/svg/arrow-right-grey.svg" />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
